
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import NotFound from '../pages/NotFound';
import ThanksPage from '../pages/thanks/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/thanks',
    element: <ThanksPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
